export { withDeferredWrmLoaded } from './with-deferred-wrm-loaded';
